import React from 'react';
import { StarIcon, QuoteIcon, CheckCircle2Icon } from 'lucide-react';
const testimonials = [{
  name: 'María L.',
  age: 42,
  city: 'Buenos Aires',
  highlight: '-4kg en 21 días',
  text: 'Pensé que era mi edad… pero era mi metabolismo bloqueado. En 10 días dejé de estar inflamada TODO el tiempo.'
}, {
  name: 'Carolina P.',
  age: 35,
  city: 'Córdoba',
  highlight: 'Chau hinchazón',
  text: 'Por primera vez entendí por qué no bajaba de peso. No era la comida… era mi cuerpo.'
}, {
  name: 'Luciana M.',
  age: 28,
  city: 'Rosario',
  highlight: 'Sin ansiedad',
  text: 'Mi mayor problema era el picoteo nocturno. Con este método aprendí a comer para estar saciada. Bajé 3 kilos y medio, pero lo mejor es la paz mental que tengo ahora con la comida.'
}, {
  name: 'Sandra G.',
  age: 51,
  city: 'Mendoza',
  highlight: 'Metabolismo activo',
  text: 'Estaba estancada hace años por la menopausia. El plan de 21 días me ayudó a destrabar mi metabolismo. Me siento deshinchada, duermo mejor y la ropa me vuelve a quedar suelta.'
}];
export function Testimonials() {
  return <section className="py-20 bg-blush/30" data-id="element-251">
      <div className="container mx-auto px-4 max-w-6xl fade-in-section" data-id="element-252">
        <div className="text-center mb-16" data-id="element-253">
          <h2 className="text-3xl md:text-4xl font-bold text-text-dark mb-4" data-id="element-254">
            Mirá lo que dicen las mujeres que ya lo probaron
          </h2>
          <p className="text-lg text-text-medium mb-6" data-id="element-255">
            Resultados reales de mujeres reales.
          </p>

          <div className="flex flex-wrap justify-center gap-3" data-id="element-256">
            <span className="bg-white px-4 py-1.5 rounded-full text-sm font-bold text-text-dark shadow-sm border border-gray-100" data-id="element-257">
              3.247+ clientas
            </span>
            <span className="bg-white px-4 py-1.5 rounded-full text-sm font-bold text-text-dark shadow-sm border border-gray-100 flex items-center gap-1" data-id="element-258">
              4.8 <StarIcon className="w-4 h-4 text-yellow-500 fill-current" data-id="element-259" />{' '}
              promedio
            </span>
            <span className="bg-white px-4 py-1.5 rounded-full text-sm font-bold text-text-dark shadow-sm border border-gray-100" data-id="element-260">
              97% recomiendan
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-261">
          {testimonials.map((t, index) => <div key={index} className="bg-white p-8 rounded-3xl shadow-soft relative" data-id="element-262">
              <div className="absolute top-6 right-6 flex items-center gap-1 text-xs font-bold text-sage bg-sage-light/30 px-2 py-1 rounded-md" data-id="element-263">
                <CheckCircle2Icon className="w-3.5 h-3.5" data-id="element-264" />
                VERIFICADO
              </div>

              <QuoteIcon className="absolute top-6 right-8 text-rose/20 w-16 h-16 opacity-50" data-id="element-265" />

              <div className="flex items-center mb-4 mt-2" data-id="element-266">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="text-yellow-400 fill-current w-5 h-5" data-id="element-267" />)}
              </div>

              <div className="inline-block bg-sage-light/50 text-sage-dark font-bold px-3 py-1 rounded-full text-sm mb-4" data-id="element-268">
                {t.highlight}
              </div>

              <p className="text-text-dark text-lg italic mb-6 relative z-10" data-id="element-269">
                "{t.text}"
              </p>

              <div className="flex items-center" data-id="element-270">
                <div className="w-12 h-12 bg-gradient-to-br from-rose to-coral rounded-full flex items-center justify-center text-white font-bold text-xl mr-4" data-id="element-271">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-272">
                  <p className="font-bold text-text-dark" data-id="element-273">{t.name}</p>
                  <p className="text-sm text-text-medium" data-id="element-274">
                    {t.age} años, {t.city}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}